// import React, { useState, useEffect } from 'react';
// import Plot from 'react-plotly.js';
// import {

//   fetchCustomerMarketSegmentBoxPlot,
//   fetchSalesRevenueBoxPlot,
//   fetchPremisesMeasurementBoxPlot,
//   fetchVerticalMarketSegmentBoxPlot,
//   fetchVerticalSalesRevenueBoxPlot,
//   fetchVerticalPremisesMeasurementBoxPlot
// } from '../api'; // Adjust the path as necessary
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   Box,
//   CircularProgress,
// } from '@mui/material'; // Import Material-UI components
// import './DataInputs.css'; // Custom CSS
// import axios from 'axios';

// function DataInputs() {
//   const [pcaPlotData, setPcaPlotData] = useState([]);
//   const [dataInputs, setDataInputs] = useState(null);
//   const [customerMarketSegmentBoxPlot, setCustomerMarketSegmentBoxPlot] = useState(null);
//   const [salesRevenueBoxPlot, setSalesRevenueBoxPlot] = useState(null);
//   const [premisesMeasurementBoxPlot, setPremisesMeasurementBoxPlot] = useState(null);
//   const [verticalMarketSegmentBoxPlot, setVerticalMarketSegmentBoxPlot] = useState(null);
//   const [verticalSalesRevenueBoxPlot, setVerticalSalesRevenueBoxPlot] = useState(null);
//   const [verticalPremisesMeasurementBoxPlot, setVerticalPremisesMeasurementBoxPlot] = useState(null);
//   const API_BASE_URL = 'http://localhost:5009';
//   useEffect(() => {
//     // let isMounted = true;
//     async function fetchData() {
//       try {
//         const [ customerMarketSegment, salesRevenue, premisesMeasurement, verticalMarketSegment, verticalSalesRevenue, verticalPremisesMeasurement] = await Promise.all([


//           fetchCustomerMarketSegmentBoxPlot(),
//           fetchSalesRevenueBoxPlot(),
//           fetchPremisesMeasurementBoxPlot(),
//           fetchVerticalMarketSegmentBoxPlot(),
//           fetchVerticalSalesRevenueBoxPlot(),
//           fetchVerticalPremisesMeasurementBoxPlot(),
//         ]);



//           setCustomerMarketSegmentBoxPlot(customerMarketSegment.plot);
//           setSalesRevenueBoxPlot(salesRevenue.plot);
//           setPremisesMeasurementBoxPlot(premisesMeasurement.plot);
//           setVerticalMarketSegmentBoxPlot(verticalMarketSegment.plot);
//           setVerticalSalesRevenueBoxPlot(verticalSalesRevenue.plot);
//           setVerticalPremisesMeasurementBoxPlot(verticalPremisesMeasurement.plot);
//         // }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     }

//     fetchData();

//   }, []);



// useEffect(() => {
//   const getpcaData = async() => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/pca_plot`); 
//       if (!response) {
//         throw new Error('Network response was not ok');
//       }

//       const traces3D = response.data.map((data, index) => ({
//         x: data["data"]["x-axis"],
//         y: data["data"]["y-axis"],
//         z: data["data"]["z-axis"],
//         mode: 'markers',
//         marker: {
//           size: 12,
//           line: {
//             color: 'rgba(217, 217, 217, 0.14)',
//             width: 0.5
//           },
//           opacity: 0.8
//         },
//         type: 'scatter3d',
//         name: `Cluster ${index}`
//       }));

//       setPcaPlotData({ traces3D });
//     } catch (error) {
//       console.error("Error fetching PCA plot data:", error);
//       return {}; // Return an empty object or handle error accordingly
//     }
//   }

// getpcaData()
// },[])

// useEffect(() => {

//        const getdatainput = async() => {
//         try {
//           const response = await axios.get(`${API_BASE_URL}/data_inputs`);
//         console.log("the res is",response)
//           setDataInputs(response.data)
//         } catch (error) {
//           console.error('Error fetching customer market segment box plot:', error);
//           throw error;
//         }

//        }

// getdatainput()
// },[])

//   return (
//     <div className="container p-4 bg-white shadow-md rounded-lg">
//       <Typography variant="h4" component="h1" className="text-left mb-6 text-primary">
//         Cluster Visualization
//       </Typography>

//       <Box className="plot-container-left mb-6">
//         {pcaPlotData ? (
//           <Plot
//             data={pcaPlotData.traces3D}
//             layout={{
//               title: '3D PCA Plot',
//               autosize: true,
//               width: 850, // Slightly decreased width for the PCA plot
//               height: 500,
//             }}
//             className="plot"
//           />
//         ) : (
//           <Box display="flex" justifyContent="center" alignItems="center" height="500px">
//             <CircularProgress />
//           </Box>
//         )}
//       </Box>

//       <Typography variant="h5" component="h2" className="mb-4 text-secondary">
//         Data Visualization
//       </Typography>

//       <Box className="horizontal-scroll-container mb-6">
//         {customerMarketSegmentBoxPlot && (
//           <Box className="box-plot">
//             <Plot
//               data={JSON.parse(customerMarketSegmentBoxPlot).data}
//               // data={customerMarketSegmentBoxPlot.data}
//               layout={{
//                 // ...customerMarketSegmentBoxPlot.layout,
//                 ...JSON.parse(customerMarketSegmentBoxPlot).layout,
//                 autosize: true,
//                 width: 850, // Consistent width for box plots
//                 margin: { t: 30, b: 120 },
//                 title: { text: 'Number Of Employees By Customer Market' },
//                 xaxis: { tickangle: -45 },
//                 yaxis: { title: { text: 'NUMBER OF EMPLOYEES' } },
//               }}
//               className="plot"
//             />
//           </Box>
//         )}
//         {salesRevenueBoxPlot && (
//           <Box className="box-plot">
//             <Plot
//               data={JSON.parse(salesRevenueBoxPlot).data}
//               layout={{
//                 ...JSON.parse(salesRevenueBoxPlot).layout,
//                 autosize: true,
//                 width: 850,
//                 margin: { t: 30, b: 120 },
//                 title: { text: 'Sales Revenue by Customer Market' },
//                 xaxis: { tickangle: -45 },
//                 yaxis: { title: { text: 'SALES REVENUE' } },
//               }}
//               className="plot"
//             />
//           </Box>
//         )}
//         {premisesMeasurementBoxPlot && (
//           <Box className="box-plot">
//             <Plot
//               data={JSON.parse(premisesMeasurementBoxPlot).data}
//               layout={{
//                 ...JSON.parse(premisesMeasurementBoxPlot).layout,
//                 autosize: true,
//                 width: 850,
//                 margin: { t: 30, b: 120 },
//                 title: { text: 'Premises Measurement by Customer Market' },
//                 xaxis: { tickangle: -45 },
//                 yaxis: { title: { text: 'PREMISES MEASUREMENT' } },
//               }}
//               className="plot"
//             />
//           </Box>
//         )}
//         {verticalMarketSegmentBoxPlot && (
//           <Box className="box-plot">
//             <Plot
//               data={JSON.parse(verticalMarketSegmentBoxPlot).data}
//               layout={{
//                 ...JSON.parse(verticalMarketSegmentBoxPlot).layout,
//                 autosize: true,
//                 width: 850,
//                 margin: { t: 30, b: 120 },
//                 title: { text: 'Number Of Employees By Vertical Market' },
//                 xaxis: { tickangle: -45 },
//                 yaxis: { title: { text: 'NUMBER OF EMPLOYEES' } },
//               }}
//               className="plot"
//             />
//           </Box>
//         )}
//         {verticalSalesRevenueBoxPlot && (
//           <Box className="box-plot">
//             <Plot
//               data={JSON.parse(verticalSalesRevenueBoxPlot).data}
//               layout={{
//                 ...JSON.parse(verticalSalesRevenueBoxPlot).layout,
//                 autosize: true,
//                 width: 850,
//                 margin: { t: 30, b: 120 },
//                 title: { text: 'Sales Revenue by Vertical Market' },
//                 xaxis: { tickangle: -45 },
//                 yaxis: { title: { text: 'SALES REVENUE' } },
//               }}
//               className="plot"
//             />
//           </Box>
//         )}
//         {verticalPremisesMeasurementBoxPlot && (
//           <Box className="box-plot">
//             <Plot
//               data={JSON.parse(verticalPremisesMeasurementBoxPlot).data}
//               layout={{
//                 ...JSON.parse(verticalPremisesMeasurementBoxPlot).layout,
//                 autosize: true,
//                 width: 850,
//                 margin: { t: 30, b: 120 },
//                 title: { text: 'Premises Measurement by Vertical Market' },
//                 xaxis: { tickangle: -45 },
//                 yaxis: { title: { text: 'PREMISES MEASUREMENT' } },
//               }}
//               className="plot"
//             />
//           </Box>
//         )}
//       </Box>

//       <Typography variant="h5" component="h2" className="mb-4 text-secondary">
//         Data Inputs
//       </Typography>


//       {dataInputs && (
//         <TableContainer
//           component={Paper}
//           className="table-wrapper"
//           style={{ maxHeight: '400px', width: '80%' }}
//         >
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 {Object.keys(dataInputs[0]).map((key) => (
//                   <TableCell key={key}>{key}</TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {dataInputs.map((row, idx) => (
//                 <TableRow key={idx}>
//                   {Object.values(row).map((val, i) => (
//                     <TableCell key={i}>{val}</TableCell>
//                   ))}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}

//     </div>
//   );
// }

// export default DataInputs;

import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import {
  fetchCustomerMarketSegmentBoxPlot,
  fetchSalesRevenueBoxPlot,
  fetchPremisesMeasurementBoxPlot,
  fetchVerticalMarketSegmentBoxPlot,
  fetchVerticalSalesRevenueBoxPlot,
  fetchVerticalPremisesMeasurementBoxPlot,
  fetchPcaPlot,
  fetchDataInputs,
} from '../api'; // Adjust the path as necessary
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material'; // Import Material-UI components
import './DataInputs.css'; // Custom CSS
import axios from 'axios';

function DataInputs() {
  const [pcaPlotData, setPcaPlotData] = useState([]);
  const [dataInputs, setDataInputs] = useState(null);
  const [customerMarketSegmentBoxPlot, setCustomerMarketSegmentBoxPlot] = useState(null);
  const [salesRevenueBoxPlot, setSalesRevenueBoxPlot] = useState(null);
  const [premisesMeasurementBoxPlot, setPremisesMeasurementBoxPlot] = useState(null);
  const [verticalMarketSegmentBoxPlot, setVerticalMarketSegmentBoxPlot] = useState(null);
  const [verticalSalesRevenueBoxPlot, setVerticalSalesRevenueBoxPlot] = useState(null);
  const [verticalPremisesMeasurementBoxPlot, setVerticalPremisesMeasurementBoxPlot] = useState(null);
  // const API_BASE_URL = 'https://opportunity-analysis-backend.sales-prod.aifirstlabs-relanto.com/';
  const API_BASE_URL = 'http://localhost:5009';

  useEffect(() => {
    async function fetchData() {
      try {
        const [customerMarketSegment, salesRevenue, premisesMeasurement, verticalMarketSegment, verticalSalesRevenue, verticalPremisesMeasurement] = await Promise.all([
          fetchCustomerMarketSegmentBoxPlot(),
          fetchSalesRevenueBoxPlot(),
          fetchPremisesMeasurementBoxPlot(),
          fetchVerticalMarketSegmentBoxPlot(),
          fetchVerticalSalesRevenueBoxPlot(),
          fetchVerticalPremisesMeasurementBoxPlot(),
        ]);

        setCustomerMarketSegmentBoxPlot(customerMarketSegment.plot);
        setSalesRevenueBoxPlot(salesRevenue.plot);
        setPremisesMeasurementBoxPlot(premisesMeasurement.plot);
        setVerticalMarketSegmentBoxPlot(verticalMarketSegment.plot);
        setVerticalSalesRevenueBoxPlot(verticalSalesRevenue.plot);
        setVerticalPremisesMeasurementBoxPlot(verticalPremisesMeasurement.plot);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    const getPcaData = async () => {
      try {
        const response = await fetchPcaPlot();
        const traces3D = response.map((data, index) => ({
          x: data["data"]["x-axis"],
          y: data["data"]["y-axis"],
          z: data["data"]["z-axis"],
          mode: 'markers',
          marker: {
            size: 12,
            line: {
              color: 'rgba(217, 217, 217, 0.14)',
              width: 0.5
            },
            opacity: 0.8
          },
          type: 'scatter3d',
          name: `Cluster ${index}`
        }));

        setPcaPlotData({ traces3D });
      } catch (error) {
        console.error("Error fetching PCA plot data:", error);
      }
    }

    getPcaData();
  }, []);

  useEffect(() => {
    const getDataInputs = async () => {
      try {
        const response = await fetchDataInputs();
        setDataInputs(response);
      } catch (error) {
        console.error('Error fetching data inputs:', error);
      }
    }

    getDataInputs();
  }, []);

  return (
    <div className="container p-4 bg-white shadow-md rounded-lg">
      <Typography variant="h4" component="h1" className="text-left mb-6 text-primary">
        Cluster Visualization
      </Typography>

      <Box className="plot-container-left mb-6">
        {pcaPlotData ? (
          <Plot
            data={pcaPlotData.traces3D}
            layout={{
              title: '3D PCA Plot',
              autosize: true,
              width: 850, // Slightly decreased width for the PCA plot
              height: 500,
            }}
            className="plot"
          />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="500px">
            <CircularProgress />
          </Box>
        )}
      </Box>

      <Typography variant="h5" component="h2" className="mb-4 text-secondary">
        Data Visualization
      </Typography>

      <Box className="horizontal-scroll-container mb-6">
        {customerMarketSegmentBoxPlot && (
          <Box className="box-plot">
            <Plot
              data={JSON.parse(customerMarketSegmentBoxPlot).data} // Directly use the data
              layout={{
                ...JSON.parse(customerMarketSegmentBoxPlot).layout,
                autosize: true,
                width: 850,
                margin: { t: 30, b: 120 },
                title: { text: 'Number Of Employees By Customer Market' },
                xaxis: { tickangle: -45 },
                yaxis: { title: { text: 'NUMBER OF EMPLOYEES' } },
              }}
              className="plot"
            />
          </Box>
        )}
        {salesRevenueBoxPlot && (
          <Box className="box-plot">
            <Plot
              data={JSON.parse(salesRevenueBoxPlot).data} // Directly use the data
              layout={{
                ...JSON.parse(salesRevenueBoxPlot).layout, // Directly use the layout
                autosize: true,
                width: 850,
                margin: { t: 30, b: 120 },
                title: { text: 'Sales Revenue by Customer Market' },
                xaxis: { tickangle: -45 },
                yaxis: { title: { text: 'SALES REVENUE' } },
              }}
              className="plot"
            />
          </Box>
        )}
        {premisesMeasurementBoxPlot && (
          <Box className="box-plot">
            <Plot
              data={JSON.parse(premisesMeasurementBoxPlot).data} // Directly use the data
              layout={{
                ...JSON.parse(premisesMeasurementBoxPlot).layout, // Directly use the layout
                autosize: true,
                width: 850,
                margin: { t: 30, b: 120 },
                title: { text: 'Premises Measurement by Customer Market' },
                xaxis: { tickangle: -45 },
                yaxis: { title: { text: 'PREMISES MEASUREMENT' } },
              }}
              className="plot"
            />
          </Box>
        )}
        {verticalMarketSegmentBoxPlot && (
          <Box className="box-plot">
            <Plot
              data={JSON.parse(verticalMarketSegmentBoxPlot).data} // Directly use the data
              layout={{
                ...JSON.parse(verticalMarketSegmentBoxPlot).layout, // Directly use the layout
                autosize: true,
                width: 850,
                margin: { t: 30, b: 120 },
                title: { text: 'Number Of Employees By Vertical Market' },
                xaxis: { tickangle: -45 },
                yaxis: { title: { text: 'NUMBER OF EMPLOYEES' } },
              }}
              className="plot"
            />
          </Box>
        )}
        {verticalSalesRevenueBoxPlot && (
          <Box className="box-plot">
            <Plot
              data={JSON.parse(verticalSalesRevenueBoxPlot).data} // Directly use the data
              layout={{
                ...JSON.parse(verticalSalesRevenueBoxPlot).layout, // Directly use the layout
                autosize: true,
                width: 850,
                margin: { t: 30, b: 120 },
                title: { text: 'Sales Revenue by Vertical Market' },
                xaxis: { tickangle: -45 },
                yaxis: { title: { text: 'SALES REVENUE' } },
              }}
              className="plot"
            />
          </Box>
        )}
        {verticalPremisesMeasurementBoxPlot && (
          <Box className="box-plot">
            <Plot
              data={JSON.parse(verticalPremisesMeasurementBoxPlot).data} // Directly use the data
              layout={{
                ...JSON.parse(verticalPremisesMeasurementBoxPlot).layout, // Directly use the layout
                autosize: true,
                width: 850,
                margin: { t: 30, b: 120 },
                title: { text: 'Premises Measurement by Vertical Market' },
                xaxis: { tickangle: -45 },
                yaxis: { title: { text: 'PREMISES MEASUREMENT' } },
              }}
              className="plot"
            />
          </Box>
        )}
      </Box>

      <Typography variant="h5" component="h2" className="mb-4 text-secondary">
        Data Inputs
      </Typography>

      {dataInputs && (
        <TableContainer
          component={Paper}
          className="table-wrapper"
          style={{ maxHeight: '400px', width: '80%' }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {Object.keys(dataInputs[0]).map((key) => (
                  <TableCell key={key}>{key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataInputs.map((row, index) => (
                <TableRow key={index}>
                  {Object.values(row).map((value, cellIndex) => (
                    <TableCell key={cellIndex}>{value}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}

export default DataInputs;
